<template>
    <div class="brand-marquee py-5">
        <div class="marquee-track scroll">
            <a v-for="(logo, i) in [...logos, ...logos]" :key="'top-' + i" :href="logo.link" class="marquee-link"
                target="_blank" rel="noopener">
                <img :src="CmsBaseUrl() + logo.src" :alt="logo.alt" class="marquee-logo" width="250" height="50" />
            </a>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useApolloClient } from '@vue/apollo-composable';
import { getBrandMarquee } from "@/utils/graphql";
import { CmsBaseUrl } from "@/utils/functions";

const logos = ref<Array<{ src: string; alt: string; link: string }>>([]);
const { resolveClient } = useApolloClient();
const ApolloClient = resolveClient();

onMounted(async () => {
    try {
        const result = await getBrandMarquee(ApolloClient);
        logos.value = result as Array<{ src: string; alt: string; link: string }>;
    } catch (error) {
        console.error("Failed to load brand marquee logos:", error);
    }
});
</script>

<style lang="scss" scoped>
$background-color: $nls-light;

.brand-marquee {
    position: relative;
    padding: 2rem 0;
    margin-bottom: 0;
    overflow: hidden;
    background-color: $background-color;

    &::before,
    &::after {
        content: "";
        position: absolute;
        top: 0;
        width: 80px;
        height: 100%;
        z-index: 1;
        pointer-events: none;
    }

    &::before {
        left: 0;
        background: linear-gradient(to right, $background-color, transparent);
    }

    &::after {
        right: 0;
        background: linear-gradient(to left, $background-color, transparent);
    }

    .marquee-track {
        display: flex;
        width: max-content;
        animation: scroll-left 80s linear infinite;
        align-items: center;

        &:hover {
            animation-play-state: paused;
        }

        .marquee-link {
            flex-shrink: 0;
        }

        .marquee-logo {
            max-width: fit-content;
            margin: 0 1.25rem;
            flex-shrink: 0;
            opacity: .7;
            transition: opacity .25s;
            height: 30px;

            &:hover {
                opacity: 1;
            }
        }
    }
}

@keyframes scroll-left {
    0% {
        transform: translateX(0%);
    }

    100% {
        transform: translateX(-50%);
    }
}
</style>